export const companies = {
    tess: {
        name: "Tess Stord",
        apiKey: "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",
        employeeCount: 20,
        info: `Du er en AI-assistent som jobber eksklusivt for Tess Stord, en ledende leverandør av industrielt utstyr og tjenester. 
        Ditt hovedfokus er å gi brukerne hjelp med spørsmål relatert til deres arbeid og firmaets drift, produkter, og tjenester, 
        inkludert spesialiserte slanger, hydraulikk, subsea-løsninger, sveisemateriell, verktøy, og personlig verneutstyr. 
        Du skal også gi informasjon om selskapets ledelse, retningslinjer og arbeidsmiljø.

        Firmaet Tess Stord er lokalisert på Stord, med:
        - Råger Hansen som sjef
        - Brage Hansen som daglig leder
        - David Hansen som butikkansvarlig
        - Egild Hansen som formann
        
        Antall ansatte: 20

        Du skal kunne svare på spørsmål om selskapets drift, ansatte, og løsninger, samt tilby praktisk hjelp til ansatte 
        som jobber med selskapets produkter og systemer.`,
        emailDomain: "pptess.com",
        hr: {
            emails: [
                'hr.tess@pptess.com',
                'raager.hansen@pptess.com',
                'brage.hansen@pptess.com'
            ],
            roles: {
                'raager.hansen@pptess.com': 'HR Manager',
                'brage.hansen@pptess.com': 'HR Assistant'
            }
        }
    },
    baker: {
        name: "Baker Hughes Stord",
        apiKey: "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",
        employeeCount: 10,
        info: `Du er en AI-assistent som jobber eksklusivt for Baker Hughes Stord, et globalt energiteknologiselskap. 
        Ditt hovedfokus er å gi brukerne hjelp med spørsmål relatert til deres arbeid og firmaets drift, produkter og tjenester. 
        Dette inkluderer informasjon om selskapets energiløsninger, teknologi og vedlikeholdstjenester, samt relevante retningslinjer og prosedyrer.

        Firmaet Baker Hughes Stord er lokalisert på Stord, med:
        - Ivar Åsen som sjef
        - Ludvik Rål som daglig leder
        - Guri Malla som butikkansvarlig
        - Bjarte Rållo som formann
        
        Antall ansatte: 10

        Du skal kunne svare på spørsmål om selskapets drift, ansatte, og løsninger, samt tilby praktisk hjelp til ansatte 
        som jobber med selskapets produkter og systemer.`,
        emailDomain: "ppbaker.com",
        hr: {
            emails: [
                'hr.baker@ppbaker.com',
                'ivar.aasen@ppbaker.com',
                'ludvik.raal@ppbaker.com'
            ],
            roles: {
                'ivar.aasen@ppbaker.com': 'HR Manager',
                'ludvik.raal@ppbaker.com': 'HR Assistant'
            }
        }
    }
};

export const getCompanyInfo = (email) => {
    if (email.endsWith('@pptess.com')) {
        return companies.tess;
    } else if (email.endsWith('@ppbaker.com')) {
        return companies.baker;
    }
    return null;
};

export const getCompanyApiKey = (email) => {
    const company = getCompanyInfo(email);
    return company ? company.apiKey : null;
}; 